<template>
    <div>
        <el-dialog
        :title="title[types]"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
            <div class="dialogContent">
                <div class="d1">
                    <img src="../../../assets/images/newIcon/ss_shaixuan_icon.png" alt="">
                    <el-select v-model="value" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-table
                :data="tableData"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                :cell-style="{textAlign:'center',fontSize:'12px'}"
                style="width: 100%">
                    <el-table-column
                        prop=""
                        label=""
                        width="60"
                        >
                        <template slot-scope="scope">
                            <span @click="chageS(scope.row)">
                            <el-radio v-model="checkVal" :label="scope.row.id"><span></span></el-radio>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="业务系统"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        label="分组名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="xmember"
                        label="人群定义"
                        show-overflow-tooltip
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember"
                        label="人群总数"
                        >
                    </el-table-column>
                </el-table>
                <div class="page pageL">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 24px;"
                    :current-page="query.page_index"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.page_size"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total"
                    ></el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="checkOk">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            query:JSON.parse(JSON.stringify(QUERY)),
            time:"",
            total:100,
            dialogVisible:false,
            value: '业务系统',
            types:"1",
            title:["","选择一组人群用户进行复制","请选择会员分组"],
            options: [{
            value: '选项1',
            label: '小橘帮帮'
            }, {
            value: '选项2',
            label: '颐安中台'
            }],
            checkVal:"",
            tableData: [{
                id:1,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },{
                id:2,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },{
                id:3,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },{
                id:4,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },],
        }
    },
    methods:{
        
        chageS(item){
            
        },
        checkOk(){
            this.$emit("do",{id:1111})
        },
        show(obj){
            this.dialogVisible=true;
            this.types=obj.type;
        }
    }
}
</script>
<style lang="less" scoped>
    .dialogContent{
        padding:0 10px;
        .d1{
            padding:15px;
            img{
                margin-right:15px;
                width:16px;
                height:16px;
                vertical-align: middle;
            }
            /deep/.el-input .el-input__inner{
                // border-radius: 30px;
                width:100px;
                background:#F6F6F9 ;
            }
        }
    }
    .pageL{
        /deep/.el-pager li{
            background: #F7F7F7;
            border-radius: 2px;
        }
        /deep/ .el-pager li.active{
            background: #258EF7;
            color:#fff;
        }
    }
    .dialog-footer{
            display: block;
            .el-button{
                border-radius: 30px;
            }
    }
     /deep/.el-dialog__footer{
        margin-top:30px;
        border-top:1px solid #ededed;
    }
</style>